import { router } from "@inertiajs/react"
import { useTranslation } from "react-i18next"
import { Plus } from "lucide-react"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface AccountSwitcherProps {
  accounts: Array<{ id: number; name: string; slug: string }>
  currentAccountId: number | null
}

const CREATE_NEW_VALUE = "__create_new__"

export function AccountSwitcher({ accounts, currentAccountId }: AccountSwitcherProps) {
  const { t } = useTranslation()

  function handleChange(value: string) {
    if (value === CREATE_NEW_VALUE) {
      router.visit("/accounts/new")
    } else {
      router.post("/switch-account", { account_id: value })
    }
  }

  const currentAccount = accounts.find((a) => a.id === currentAccountId)

  return (
    <Select
      value={currentAccountId?.toString()}
      onValueChange={handleChange}
    >
      <SelectTrigger className="w-full sm:w-48">
        <SelectValue placeholder={t("account.selectAccount")}>
          {currentAccount?.name || t("account.selectAccount")}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {accounts.map((account) => (
          <SelectItem key={account.id} value={account.id.toString()}>
            {account.name}
          </SelectItem>
        ))}
        <SelectSeparator />
        <SelectItem value={CREATE_NEW_VALUE}>
          <span className="flex items-center gap-2">
            <Plus className="w-4 h-4" />
            {t("account.createNew")}
          </span>
        </SelectItem>
      </SelectContent>
    </Select>
  )
}
